import React from 'react';
import RiskConfidenceBadge from './RiskConfidenceBadge';
import RiskScopeBadge from './RiskScopeBadge';

const severityClass = (severity) => {
  const key = String(severity || '').toUpperCase();
  if (key === 'CRITICAL') return 'text-red-300';
  if (key === 'HIGH') return 'text-amber-300';
  if (key === 'MEDIUM') return 'text-blue-300';
  return 'text-emerald-300';
};

const PredictiveRiskPanel = ({ risks }) => {
  const items = risks || [];

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <div className="mb-3 text-sm font-semibold text-slate-200">Top Predictive Risks</div>
      <div className="grid grid-cols-1 gap-3 xl:grid-cols-2">
        {items.map((risk) => (
          <div key={risk.riskId} className="rounded-lg border border-slate-800 bg-slate-950/80 p-3">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className={`text-sm font-semibold ${severityClass(risk.severity)}`}>{risk.title}</div>
              <RiskConfidenceBadge confidence={risk.confidence} />
            </div>
            <div className="mt-2">
              <RiskScopeBadge scopeType={risk.scopeType} scopeKey={risk.scopeKey} />
            </div>
            <p className="mt-2 text-sm text-slate-300">{risk.message}</p>
            <p className="mt-1 text-xs text-slate-400">Penyebab kemungkinan: {risk.probableCause}</p>
            <p className="mt-2 rounded-md border border-slate-700 bg-slate-900 px-2 py-1 text-xs text-blue-200">
              Rekomendasi: {risk.recommendedAction}
            </p>
          </div>
        ))}
        {items.length === 0 ? <div className="text-sm text-slate-400">Belum ada risiko prediktif prioritas.</div> : null}
      </div>
    </div>
  );
};

export default PredictiveRiskPanel;
